import { useEffect } from "react";
import { X } from "lucide-react";

// Painel lateral (slide-over) — usado pros detalhes, que ficam ao lado da lista em vez de
// cobrir a tela inteira. Fecha com Esc ou clicando fora.
export const Drawer = ({ isOpen, onClose, title, children, footer, width = 'max-w-lg' }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = overflow;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <div className="absolute inset-0 animate-fade-in bg-gray-900/25 backdrop-blur-[2px]" onClick={onClose} />
      <aside className={`relative flex h-full w-full ${width} animate-slide-in flex-col bg-white shadow-2xl sm:m-3 sm:h-[calc(100%-1.5rem)] sm:rounded-2xl`}>
        <header className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 transition hover:bg-gray-100 hover:text-gray-700"
            aria-label="Fechar"
          >
            <X className="h-4 w-4" />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto">{children}</div>
        {footer && <footer className="border-t border-gray-100 px-5 py-4">{footer}</footer>}
      </aside>
    </div>
  );
};
